import { ViaductAction, ViaductLinkData, ViaductLinkRegex } from "./constants";

export const parseViaductLink = (
  viaductLinkString: string
): ViaductLinkData | null => {
  const match = viaductLinkString.match(ViaductLinkRegex);

  if (!match) {
    return null;
  }

  const [, linkText, action, actionParameter] = match;

  // invalid action parameter
  if (Object.values(ViaductAction).indexOf(action as any) === -1) {
    return null;
  }

  let decodedActionParameter = "";
  try {
    decodedActionParameter = decodeURIComponent(actionParameter);
  } catch (err) {
    console.warn("Failed to decode Viaduct link action parameter:", err);
  }

  return {
    linkText,
    action: action as ViaductAction,
    actionParameter: decodedActionParameter,
  };
};
